<template>
  <AppLoader
    :isVisible="isVisible"
    variant="fullscreen"
    :message="message || 'Loading Student Data...'"
    :subtext="subtext || 'Please wait while we prepare student records...'"
    color="indigo"
    icon="cap"
  />
</template>

<script setup>
import AppLoader from "@/components/common/AppLoader.vue";

defineProps({
  isVisible: {
    type: Boolean,
    default: false,
  },
  message: {
    type: String,
    default: "Loading...",
  },
  subtext: {
    type: String,
    default: "Please wait while we load student data...",
  },
});
</script>
